import { useEffect, useState } from "react";
import "./BookingsList.scss";
import { axiosInstance } from "../../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../../Utilities/Constants/ApiEndpoints";
import { API_RESPONSE, NUMBER_CONSTANTS, STORAGE_KEYS } from "../../../../Utilities/Constants/Constants";
import { Avatar, AvatarGroup, Card, Pagination } from "@mui/material";
import { useNavigate } from "react-router-dom";
import moment from 'moment';
import NoDataFound from "../../../../Shared/NoDataFound/NoDataFound";
import EventIcon from '@mui/icons-material/Event';
import ListIcon from '@mui/icons-material/List';
import { GetSessionStorageData } from "../../../../Services/Helpers/Helper";

const BookingsList = () => {
  const [bookingsList, setBookingsList] = useState([]);
  const [totalPage, setTotalPage] = useState<any>(0);
  const [rowPerPage, setRowPerPage] = useState(9);
  const [page, setPage] = useState(1);
  const [hasProducts, setHasProducts] = useState(API_RESPONSE.TRUE);
  const navigate = useNavigate();

  /* Calling get bookings list function call */
  useEffect(() => {
    getBookingsList();
  }, [page]);

  /* Bookings List API call */
  const getBookingsList = () => {
    axiosInstance
      .post(API_END_POINTS.BOOKINGS_LIST, {
        page: page,
        limit: rowPerPage,
      })
      .then((response: any) => {
        if (response.data.status === API_RESPONSE.TRUE) {
          setBookingsList(response.data.result.data);
          const totalItems = response.data.result.total_count;
          setTotalPage(Math.ceil(totalItems / rowPerPage))
          response?.data?.result?.data?.length > NUMBER_CONSTANTS.ZERO ? setHasProducts(API_RESPONSE.TRUE) : setHasProducts(API_RESPONSE.FALSE);
        }
      });
  };
  const handleChangePage = (event: React.ChangeEvent<any>, newPage: number) => {
    console.log("🚀 ~ handleChangePage ~ newPage:", newPage)
    setPage(newPage);
    setRowPerPage(9)
  };
  return (
    <div className="bookings-list-wraper">
      {hasProducts && <div className="row">

        {GetSessionStorageData(STORAGE_KEYS.ROLE) == `${NUMBER_CONSTANTS.FIVE}` ? (
          <>
            {bookingsList.map((detail: any, index: any) => {
              return (
                <div className="col-md-6">
                  <Card key={index + 1} className="card-wrapper" >
                    <p className="session-title"> {detail?.category_name}</p>
                    <p className="session-title-sub"> {detail?.camp_session_title}</p>
                    <p className="date-display"> <span>{detail?.start_date}</span> - <span>{detail?.end_date}</span> </p>
                    <p className="date-display"> <span>{detail?.start_time}</span> - <span>{detail?.end_time}</span> </p>
                    <div className="count-wrapper_camp">
                      <div className="count-card__camp">
                        <p className="card-count">{detail?.total_class < NUMBER_CONSTANTS.TEN ? `${NUMBER_CONSTANTS.ZERO}` + detail?.total_class : detail?.total_class}</p>
                        <p>Total class</p>
                      </div>
                      <div className="count-card__camp">
                        <p className="card-count">{detail?.booked_session < NUMBER_CONSTANTS.TEN ? `${NUMBER_CONSTANTS.ZERO}` + detail?.booked_session : detail?.booked_session}</p>
                        <p>Booked Session</p>
                      </div>
                      <div className="count-card__camp">
                        <p className="card-count">{detail?.total_batch_size < NUMBER_CONSTANTS.TEN ? `${NUMBER_CONSTANTS.ZERO}` + detail?.total_batch_size : detail?.total_batch_size}</p>
                        <p>Total Batch Size</p>
                      </div>
                      <div className="count-card__camp">
                        <p className="card-count">{detail?.batch_size < NUMBER_CONSTANTS.TEN ? `${NUMBER_CONSTANTS.ZERO}` + detail?.batch_size : detail?.batch_size}</p>
                        <p>Batch Size</p>
                      </div>
                      {/* <div className="count-card">
                        <p className="card-count">{detail?.unbooked_slots_count < NUMBER_CONSTANTS.TEN ? `${NUMBER_CONSTANTS.ZERO}` + detail?.unbooked_slots_count : detail?.unbooked_slots_count}</p>
                        <p>Available</p>
                      </div> */}
                    </div>

                    {/* {detail?.booked_user_profiles?.length > NUMBER_CONSTANTS.ZERO &&
                      <div className="avatar-wrapper">
                        <AvatarGroup max={NUMBER_CONSTANTS.TEN} total={detail?.booked_user_profiles?.length}>
                          {detail?.booked_user_profiles?.map((profile: any, index: any) => {
                            return (
                              <Avatar className="user-profile" alt="booked_user" src={profile} />
                            )
                          })}

                        </AvatarGroup>
                      </div>
                    } */}
                    <hr className="mt-3" />
                    <div className="view-container">
                      {/* <div className="calender-view" onClick={() => {
                        navigate(`/manage-bookings/calender/${detail?.id}`)
                      }}>
                        <EventIcon className="event-icon" />
                        <p>Calender View</p>
                      </div> */}
                      <div className="list-view" onClick={() => {
                        navigate(`/manage-bookings/list/${detail?.id}`)
                      }}>
                        <ListIcon className="event-icon" />
                        <p>List View</p>
                      </div>
                    </div>
                  </Card>
                </div>
              );
            })}
          </>
        ) : (
          <>
            {bookingsList.map((detail: any, index: any) => {
              return (
                <div className="col-md-4">
                  <Card key={index + 1} className="card-wrapper" >
                    <p className="session-title"> {detail?.session_title}</p>
                    <p className="date-display"> <span>{moment(detail?.start_date).format('DD-MM-YYYY')}</span> - <span>{moment(detail?.end_date).format('DD-MM-YYYY')}</span> </p>
                    <div className="count-wrapper">
                      <div className="count-card">
                        <p className="card-count">{detail?.total_slots_count < NUMBER_CONSTANTS.TEN ? `${NUMBER_CONSTANTS.ZERO}` + detail?.total_slots_count : detail?.total_slots_count}</p>
                        <p>Total</p>
                      </div>
                      <div className="count-card">
                        <p className="card-count">{detail?.booked_slots_count < NUMBER_CONSTANTS.TEN ? `${NUMBER_CONSTANTS.ZERO}` + detail?.booked_slots_count : detail?.booked_slots_count}</p>
                        <p>Booked</p>
                      </div>
                      <div className="count-card">
                        <p className="card-count">{detail?.unbooked_slots_count < NUMBER_CONSTANTS.TEN ? `${NUMBER_CONSTANTS.ZERO}` + detail?.unbooked_slots_count : detail?.unbooked_slots_count}</p>
                        <p>Available</p>
                      </div>
                      {GetSessionStorageData(STORAGE_KEYS.ROLE) == `${NUMBER_CONSTANTS.FOUR}` && <div className="count-card">
                        <p className="card-count">{detail?.did_not_attend < NUMBER_CONSTANTS.TEN ? `${NUMBER_CONSTANTS.ZERO}` + detail?.did_not_attend : detail?.did_not_attend}</p>
                        <p>Not Attended</p>
                      </div>}
                    </div>
                    {detail?.booked_user_profiles.length === NUMBER_CONSTANTS.ZERO && <div className="avatar-wrapper-empty mt-3"></div>}
                    {detail?.booked_user_profiles.length > NUMBER_CONSTANTS.ZERO &&
                      <div className="avatar-wrapper">
                        <AvatarGroup max={NUMBER_CONSTANTS.TEN} total={detail?.booked_user_profiles.length}>
                          {detail?.booked_user_profiles.map((profile: any, index: any) => {
                            return (
                              <Avatar className="user-profile" alt="booked_user" src={profile} />
                            )
                          })}

                        </AvatarGroup>
                      </div>
                    }
                    <hr className="mt-3" />
                    <div className="view-container">
                      <div className="calender-view" onClick={() => {
                        navigate(`/manage-bookings/calender/${detail.id}`)
                      }}>
                        <EventIcon className="event-icon" />
                        <p>Calender View</p>
                      </div>
                      <div className="list-view" onClick={() => {
                        navigate(`/manage-bookings/list/${detail.id}`)
                      }}>
                        <ListIcon className="event-icon" />
                        <p>List View</p>
                      </div>
                    </div>
                  </Card>
                </div>
              );
            })}
          </>
        )}





      </div>}
      {
        hasProducts && <div className="pagination">
          <Pagination page={page} count={totalPage} color="primary" onChange={handleChangePage} />

        </div>
      }

      {!hasProducts && <NoDataFound />}
    </div>
  );
};

export default BookingsList;
